import script from "./AllNotificationsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AllNotificationsPage.vue?vue&type=script&setup=true&lang=ts"

import "./AllNotificationsPage.vue?vue&type=style&index=0&id=2f352f84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f352f84"]])

export default __exports__